import React from 'react'
import {clientConfig} from '@modifi/client-config'
import {TaskCategory} from '@modifi/enums'

import {docUpoadCategories, bsrLimitsCategories} from '../actions/constants'
import {Task} from '../../constants'
import {StyledLink} from '../../../../components/table/styles'
import {getDocUploadLinkPattern, getTaskUrlPath} from '../actions/utils'
import {ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE} from '../../../../routes/onboarding-routes'

type RelatedLinksTypes = {
  task: Task
}

const RelatedLinks: React.FC<RelatedLinksTypes> = ({task}) => {
  if (docUpoadCategories.includes(task.category as TaskCategory)) {
    return (
      <StyledLink
        pattern={getDocUploadLinkPattern(task.category)}
        to={`${clientConfig.get('SERVICE_ACTIVATIONS')}${getTaskUrlPath(task, true)}`}
        isExternal
        scrollToTop
        targetBlank
      >
        {[
          TaskCategory.COMPANY_FINANCIAL_REVIEW,
          TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW,
        ]?.includes(task.category)
          ? task?.contextParameters?.find(param => param?.key === 'financialYearLabel')?.value
          : task?.contextParameters?.[0]?.value}
      </StyledLink>
    )
  }
  if (bsrLimitsCategories.includes(task.category as TaskCategory)) {
    return (
      <StyledLink
        pattern={ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE}
        to={`${clientConfig.get('SERVICE_ACTIVATIONS')}${getTaskUrlPath(task)}`}
        isExternal
        scrollToTop
        targetBlank
      >
        {task?.contextParameters?.find(param => param?.key === 'tradePartnerCompanyName')?.value ||
          ''}
      </StyledLink>
    )
  }
  return null
}

export default RelatedLinks
